import React, { Component } from 'react';

// Externals
import classNames from 'classnames';
import PropTypes from 'prop-types';

// Material helpers
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Popover from '@material-ui/core/Popover';
// Shared components
import Paper from 'components/Paper';
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletContent from 'components/PortletContent';
import PortletLabel from 'components/PortletLabel';
import PortletFooter from 'components/PortletFooter';
import Period from '../../../../helpers/PeriodWeighted';
import { getSpecialMethod } from '../../../../services/specials/getSpecial'
import ReportLegacy from './ReportLegacy'
import WaitServer from '../../../../utils/WaitServer'
import Error from '../../../../utils/Error'
import Filter from '../../../../helpers/Filter'
import { Grid } from '@material-ui/core';

// Component styles
import styles from './styles';

import moment from 'moment-timezone'
import 'moment/locale/es'
import { Typography } from '@material-ui/core';
moment.locale('es')

class LegacyExcel extends Component {
  constructor(props) {
    super(props);
    var configSpecial = JSON.parse(sessionStorage.getItem("objetivoConfigSpecial"))
    var setupSpecial = JSON.parse(sessionStorage.getItem("setupSpecial"))
    var scheduleSpecial = JSON.parse(sessionStorage.getItem("scheduleSpecial"))
    var typesSpecial = JSON.parse(sessionStorage.getItem("typesSpecial"))
    var esPdf = true
    if ((typesSpecial.filter(i => i["content-type"] === "pdf")).length === 0) {
      esPdf = false
    }
    var schedule = false
    var objButton = false
    var periodButton = false
    var reportBoolean = false
    var listObjs = []
    var scheduleList = []
    var interval = "interval"
    if (scheduleSpecial.length > 0 && scheduleSpecial[0].selector === "true") {
      schedule = true
      scheduleList = JSON.parse(sessionStorage.getItem("horarios"))
    }
    if (typeof (configSpecial.selector) !== "undefined" && configSpecial.selector === "true") {
      objButton = true
      listObjs = JSON.parse(sessionStorage.getItem("objetivosSpecial"))
    } else {
      listObjs = [{ id: this.props.data.match.params.objetivo_id }]
    }
    if (listObjs.length == 0) {
      listObjs = [{ id: this.props.data.match.params.objetivo_id }]
    }
    if (typeof (setupSpecial.date_selection) !== "undefined" && (setupSpecial.date_selection === "interval" || setupSpecial.date_selection === "day")) {
      periodButton = true
      interval = setupSpecial.date_selection
    }
    if (JSON.parse(sessionStorage.getItem("setupSpecial")).lista_informes.length > 0) {
      reportBoolean = true
    }
    this.handleInfoAutoComplete = this.handleInfoAutoComplete.bind(this);
    this.state = {
      nameObjective: this.props.data.match.params.nombre_objetivo,
      objective: this.props.data.match.params.objetivo_id,
      method: this.props.method,
      error: false,
      load: true,
      period: "d",
      typePeriod: 1,
      namePeriod: 'Rango: último día',
      statePeriod: {},
      periodEl: null,
      objButton: objButton,
      periodButton: periodButton,
      listObjs: listObjs,
      objChild: listObjs[0],
      schedule: schedule,
      scheduleList: scheduleList,
      scheduleName: { "horario_id": 0, "nombre": "Todo Horario" },
      listReport: JSON.parse(sessionStorage.getItem("setupSpecial")).lista_informes,
      reportBoolean: reportBoolean,
      indexReport: 0,
      report: [],
      esPdf: esPdf,
      interval: interval,
      showReportLegacy: false,
      isDisabledButtonDownloadExcel: false
    }
  }

  componentDidMount() {
    this.getSpecial()
  }

  componentDidUpdate(prevProps, prevState) {
    if (JSON.parse(sessionStorage.getItem("setupSpecial")).lista_informes.length > 0) {
      if (JSON.parse(sessionStorage.getItem("setupSpecial")).lista_informes[prevState.indexReport].nombre !== this.state.listReport[this.state.indexReport].nombre) {
        this.getSpecial()
      }
    }
    if (prevState.period !== this.state.period) {
      this.getSpecial()
    }
  }

  getSpecial = () => {
    const { objective, objChild, nameObjective, scheduleName, listReport, indexReport, reportBoolean,
      objButton, periodButton, period, statePeriod, esPdf } = this.state
    const token = sessionStorage.getItem('key')
    const user = sessionStorage.getItem('user')
    const method = sessionStorage.getItem("methodSpecial")
    var scheduleId = scheduleName.horario_id
    const acentos = { 'á': 'a', 'é': 'e', 'í': 'i', 'ó': 'o', 'ú': 'u', 'Á': 'A', 'É': 'E', 'Í': 'I', 'Ó': 'O', 'Ú': 'U' };
    var name = nameObjective.split('').map(letra => acentos[letra] || letra).join('').toString()
    var args = [name, scheduleId]
    if (esPdf === true) {
      if (objButton === true) {
        args.push(objChild.id)
      }
      if (periodButton === true) {
        var begin = moment().tz(sessionStorage.getItem('tz')).subtract({ "days": 1 })
        var final = moment().tz(sessionStorage.getItem('tz'))
        if (period === "3d") {
          begin = moment().subtract({ "days": 3 })
        }
        if (period === "w") {
          begin = moment().subtract({ "days": 7 })
        }
        if (period === "c") {
          begin = moment(statePeriod.startDate)
          final = moment(statePeriod.endDate).add({ 'days': 1 })
        }
        args.push('&esPeriod=1' + '&inicio=' + String(begin.format("YYYY-MM-DD")) + '&termino=' + String(final.format("YYYY-MM-DD")))
      }
      if (reportBoolean === true) {
        args.push('&esReport=' + listReport[indexReport].nombre + '&inicio=' + String(listReport[indexReport].dia_inicio) + '&termino=' + String(listReport[indexReport].dia_termino))
      }
      args = args.toString()
      getSpecialMethod(objective, user, token, method, args).then(value => {
        try {
          if (value.estado === "exito") {
            this.setState({
              report: value.report,
              load: false
            });
          } else {
            this.setState({
              error: true,
              load: false
            });
          }
        } catch (error) {
          this.setState({
            error: true,
            load: false
          });
        }
      })
    } else {
      this.setState({
        report: [],
        load: false
      });
    }

  }

  handleInfoAutoComplete(tag, info) {
    if (tag === "Horarios") {
      this.setState({
        scheduleName: info,
        showReportLegacy: false
      });
    }
    if (tag === "Monitoreos") {
      this.setState({
        objChild: info,
        showReportLegacy: false
      });
    }
  }

  handlePeriodClick = (prevPeriod, prevTypeGraph, statePeriod, nextPeriod) => {
    if (nextPeriod === 'dia') {
      this.setState({
        period: "d",
        typePeriod: 1,
        namePeriod: 'Rango: último día',
        statePeriod: {},
        periodEl: null,
        showReportLegacy: false
      });
    } else if (nextPeriod === '3dia') {
      this.setState({
        period: "3d",
        typePeriod: 5,
        namePeriod: 'Rango: últimos 3 días',
        statePeriod: {},
        periodEl: null,
        showReportLegacy: false
      });
    } else if (nextPeriod === 'semana') {
      this.setState({
        period: "w",
        typePeriod: 2,
        namePeriod: 'Rango: última semana',
        statePeriod: {},
        periodEl: null,
        showReportLegacy: false
      });
    } else if (nextPeriod === 'custom') {
      this.setState({
        period: "c",
        typePeriod: 3,
        namePeriod: 'Rango: ' + moment(statePeriod.startDate).format("YYYY-MM-DD") + ' a ' + moment(statePeriod.endDate).add("days", 1).format("YYYY-MM-DD"),
        statePeriod: statePeriod,
        periodEl: null,
        showReportLegacy: false
      });
    }
  }

  handleShowPeriod = event => {
    this.setState({
      periodEl: event.currentTarget
    });
  };

  handleClosePeriod = () => {
    this.setState({
      periodEl: null
    });
  };

  changeReport = (index) => {
    this.setState({
      indexReport: index
    });
  }


  createReport = (ele, i) => {
    const { indexReport } = this.state
    var color = "white"
    var textColor = "#bfbfbf"
    if (indexReport === i) {
      color = "#bfbfbf"
      textColor = "white"
    }
    return (<Grid
      key={ele.nombre}
      item
      xs={2}
      sm={2}
      md={2}
      xl={2}

    >
      <Button style={{ backgroundColor: color, minWidth: "45px", height: "50px", left: "-10px" }} onClick={this.changeReport.bind(this, i)}>
        <Typography style={{ fontSize: "10px", color: textColor }} variant="h6">{ele.nombre}</Typography>
      </Button>
    </Grid>
    )
  }

  handleReportLegacy = event => {
    this.setState({
      showReportLegacy: true,
      isDisabledButtonDownloadExcel: true
    });
    setTimeout(() => this.setState({
      isDisabledButtonDownloadExcel: false
    }), 10000);
  };

  render() {
    const { classes, className, ...rest } = this.props;
    const { periodEl, period, namePeriod, nameObjective, periodButton, objButton, listObjs, objChild, objective, load, error, report,
      schedule, scheduleList, scheduleName, listReport, reportBoolean, indexReport, esPdf, statePeriod, interval, showReportLegacy,
      isDisabledButtonDownloadExcel } = this.state
    const showPeriodEl = Boolean(periodEl);

    if (load === true) {
      return (
        <PortletContent style={{ height: "100%", backgroundColor: "white" }}>
          <WaitServer />
        </PortletContent>
      )
    } else if (error === true) {
      return (
        <PortletContent style={{ height: "100%" }}>
          <Error />
        </PortletContent>
      )

    } else {
      return (
        <Portlet
          style={{ width: "95%" }}
        >
          <PortletHeader >

            <Grid
              container
              spacing={1}
            >
              <Grid
                item
                xs={3}
                sm={3}
                md={3}
                xl={3}
              >
                <Typography variant="h3" style={{ color: '#66788A' }}  >{nameObjective}</Typography>
              </Grid>
              <Grid
                item
                xs={3}
                sm={3}
                md={3}
                xl={3}
              >
                {reportBoolean ?

                  <Grid
                    container
                    spacing={6}
                  >
                    {listReport.map((ele, i) => (
                      this.createReport(ele, i)

                    ))}
                  </Grid>
                  : null}
              </Grid>
              <Grid
                item
                xs={2}
                sm={2}
                md={2}
                xl={2}
              >
                {periodButton ?
                  <Button style={{ fontSize: '15px', float: 'left', color: '#66788A' }} onClick={this.handleShowPeriod}>
                    {namePeriod}<ArrowDropDownIcon />
                  </Button>
                  : null}
              </Grid>
              <Grid
                item
                xs={2}
                sm={2}
                md={2}
                xl={2}
              >
                {schedule ?
                  <Filter list={scheduleList} label="Horarios" placeholder="Filtro de Horarios" InfoAutoComplete={this.handleInfoAutoComplete} />
                  : null}
              </Grid>
              {objButton ?
                <Grid
                  item
                  xs={2}
                  sm={2}
                  md={2}
                  xl={2}
                >
                  <Filter list={listObjs} label="Monitoreos" placeholder="Filtro de Monitoreo" InfoAutoComplete={this.handleInfoAutoComplete} />
                </Grid>
                : null}
            </Grid>
          </PortletHeader>
          <Grid
            container
            spacing={1}
            justify="center"
          >
          </Grid>
          {showReportLegacy ? <ReportLegacy obj={objChild} pdf={esPdf} parentObj={objective} objButton={objButton} report={report}
                                reportBoolean={reportBoolean} indexReport={indexReport} listReport={listReport[indexReport]}
                                scheduleBoolean={schedule} periodBoolean={periodButton} namePeriod={namePeriod}
                                horario_id={scheduleName.horario_id} nombre_horario={scheduleName.name} state={statePeriod}
                                period={period}/>
            : null}
          <PortletFooter>
            <Popover
              anchorEl={periodEl}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              onClose={this.handleClosePeriod}
              open={showPeriodEl}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center'
              }}>
              <Period onClick={this.handlePeriodClick} period={period} interval={interval} />
            </Popover>
          </PortletFooter>
        </Portlet>
      );
    }
  }
}

LegacyExcel.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(LegacyExcel);
